const baseUrl = 'onboarding';

export const ApiOnBoarding = {
  // POST /onboarding/sessions - create or resume an OnboardingSession (bootstrap JWT only)
  Sessions: `${baseUrl}/sessions`,
  // GET /onboarding/sessions/{id} - fetch/resume session state
  SessionDetail: (id: string) => `${baseUrl}/sessions/${id}`,
  // POST /onboarding/sessions/{id}/role - select SELF/NOK
  SessionRole: (id: string) => `${baseUrl}/sessions/${id}/role`,
  // POST /onboarding/sessions/{id}/lookup - look up a B3 client by NRIC
  SessionLookup: (id: string) => `${baseUrl}/sessions/${id}/lookup`,
  // POST /onboarding/sessions/{id}/complete - mint the full JWT, create/confirm the B3 client
  SessionComplete: (id: string) => `${baseUrl}/sessions/${id}/complete`,
  // POST /onboarding/sessions/{id}/mobile-update-request - manual mobile-update support request
  SessionMobileUpdateRequest: (id: string) => `${baseUrl}/sessions/${id}/mobile-update-request`,
  // POST /onboarding/sessions/{id}/otp/send - send a 6-digit OTP to the B3 client's mobile
  SessionOtpSend: (id: string) => `${baseUrl}/sessions/${id}/otp/send`,
  // POST /onboarding/sessions/{id}/otp/verify - verify the submitted OTP code
  SessionOtpVerify: (id: string) => `${baseUrl}/sessions/${id}/otp/verify`
};
